import Solution from "./solution";
import compare from "../../Utils/compare";

const testCases = [
  {
    arr: [2, 4, 4, 3, 3, 7, 7, 7, 8],
    k: 3,
  },
  {
    arr: [2, 4, 4, 3, 3, 7, 7, 7, 8],
    k: 4,
  },
  {
    arr: [2, 4, 4, 3, 3, 7, 7, 7, 8],
    k: 2,
  },
  {
    arr: [1, 2, 3, 5, 6],
    k: 1,
  },
  {
    arr: [2, 4, 4, 3, 3, 7, 7, 7, 8],
    k: 1,
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { arr, k } = test;
      let outcome1 = output()(arr, k);
      let outcome2 = Solution(arr, k);
      const result = outcome1 === outcome2;
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
